import React, { useState, useEffect } from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";


const UploadBanner = ({ columns, data }) => {
  
    const { getTableProps, getTableBodyProps, rows, headerGroups, page, nextPage, previousPage, canPreviousPage, canNextPage, pageOptions, state, gotoPage, setPageSize, prepareRow, setGlobalFilter } = useTable(
        {
            columns,
            data,
 
        },
        useGlobalFilter,
        usePagination
    );
    const { pageIndex, pageSize } = state;

    const handlePageIndex = (event) => {
        if (event.target.value !== "") {
            const number = event.target.value ? Number(event.target.value) - 1 : 0;
            gotoPage(number);
        }
    };

    return (
        <div className="customTable">
          
            <div className="customTable__body">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered" {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup) => {
                                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                                return (
                                    <tr key={key} {...headerGroupProps}>
                                        {headerGroup.headers.map((column) => {
                                            const { key, ...headerProps } = column.getHeaderProps();
                                            return <th key={key} {...headerProps}>{column.render("Header")}</th>;
                                        })}
                                    </tr>
                                );
                            })}
                        </thead>
                        {data?.length ? (
                            <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                    prepareRow(row);
                                    const { key, ...rowProps } = row.getRowProps();
                                    return (
                                        <tr key={key} {...rowProps}>
                                            {row.cells.map((cell) => {
                                                const { key, ...cellProps } = cell.getCellProps();
                                                return <td key={key} {...cellProps}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={9}>
                                        <p style={{ textAlign: "center", margin: 0 }}>No data found</p>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
          
        </div>
    );
};

export default UploadBanner;
